// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"rE-z","smallCardRow":"sE-z","largeCardRow":"tE-z","productSearchRow":"uE-z","curatedRow":"vE-z"};